import React from 'react';
import { Button, Typography, Dropdown, Menu, Badge, Tag, Checkbox, Tooltip } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import CommentDate from './comment-date';
import Avatar from '../../avatar/avatar';
// Hooks

export default function CommentHeader({
  comment: propsComment,
  showReplies: propsShowReplies,
  toggleReplies: propsToggleReplies,
  onClickEdit: propsOnClickEdit,
  editMode: propsEditMode,
  deleted: propsDeleted,
  onClickDelete: propsOnClickDelete,
  userPermission: propsUserpermission,
  unread: propsUnread,
  onClickHide: propsOnClickHide,
  isChild: propsIsChild,
  currentUserId : propsCurrentUserId,
  commentRead : propsCommentRead
}) {
  function actionPermissions() {
    // let menuActive = !propsEditMode && !propsComment.deleted;
    // If current user is author of comment return actions menu

    if (propsUserpermission && !propsEditMode && propsComment.deleted === false) {
      return (
        <>
          <Dropdown overlay={actionsDropdown}>
            <Button icon={<MoreOutlined />} size="small" />
          </Dropdown>
        </>
      );
    }
    else if(!propsEditMode && propsComment.deleted === false && propsIsChild !== true) {
      return (
        <>
          <Dropdown overlay={actionsDropdownSl}>
            <Button icon={<MoreOutlined />} size="small" />
          </Dropdown>
        </>
      );
    }

    // if (propsUserpermission && menuActive)
    //   // If current user is not author of a comment that is not deleted only show reply
    //   return (
    //     !propsEditMode &&
    //     !propsComment.deleted && [
    //       <Dropdown overlay={actionsDropdown}>
    //         <Button icon={<MoreOutlined />} size="small" />
    //       </Dropdown>,
    //     ]
    //   );
  }

  const actionsDropdownSl = (
    <Menu onClick={handleActions}>
      {propsIsChild !== true && <Menu.Item key="hide">Archive</Menu.Item>}
    </Menu>
  );

  const actionsDropdown = (
    <Menu onClick={handleActions}>
      <Menu.Item key="edit">Edit</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
      {propsIsChild !== true && <Menu.Item key="hide">Archive</Menu.Item>}
    </Menu>
  );

  function handleActions({ key }) {
    switch (key) {
      case 'edit':
        propsOnClickEdit();
        break;
      case 'delete':
        propsOnClickDelete();
        break;
      case 'hide':
        propsOnClickHide();
        break;
      default:
        break;
    }
  }

  return (
    <header
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
      }}
    >
      <div>
        {propsUnread === false && <Badge status="processing" />}
        <Avatar name={propsComment.larperName} />
        <Typography.Text strong style={{ marginRight: 8, fontSize: '12px' }}>
          {propsComment.larperName}
        </Typography.Text>
        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
          <CommentDate event={propsComment} />  
        </Typography.Text>

      </div>
      <div>
        {propsComment.onlySl && <Tag color="error">SL only</Tag>}
        {propsComment.isHidden && <Tag color="warning">Archived</Tag>}
        {propsComment.larperId !== propsCurrentUserId && <Tooltip title="If checked you read the message">
            <Checkbox checked={propsComment.isRead} 
              onChange={(value) => propsCommentRead(propsComment.id, value.target.checked)}
            />
        </Tooltip>}
        {actionPermissions()}
        </div>
    </header>
  );
}
